<template>
  <div
    id="helpDocumentsID"
    class="map-tool-window help-tool-window"
  >
    <div id="helpDocumentsIDheader" class="map-tool-window-header">
      <span class="map-tool-window-header-title">Documentación de Ayuda</span>
      <div class="map-tool-window-header-actions">
        <button class="control-btn" @click.stop="minimized = !minimized">
            <svg  v-if="minimized"
            viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <svg v-else
              viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
        </button>
        <button class="control-btn" title="Cerrar" @click.stop="close">
                        <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
    </div>
    <div v-if="!minimized" class="help-docs-body">
      <label v-if="documentGroups.length > 1" class="help-docs-group-field">
        Grupo
        <select v-model="selectedGroup" :disabled="loading" @change="loadDocuments">
          <option v-for="group in documentGroups" :key="group.id" :value="group.id">
            {{ group.name }}
          </option>
        </select>
      </label>
      <div v-if="loading" class="help-docs-state">Cargando archivos...</div>
      <div v-else-if="error" class="help-docs-state help-docs-error">{{ error }}</div>
      <div
        v-else-if="docs.length === 0"
        class="help-docs-empty"
      >
        <div class="help-docs-empty-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M6 3h9l4 4v14H6z" />
            <path d="M15 3v5h4" />
            <path d="M9 13h6" />
            <path d="M9 17h4" />
          </svg>
        </div>

        <strong>No hay documentos disponibles</strong>

        <p>
          Cuando se publiquen manuales o archivos de ayuda, aparecerán en esta sección.
        </p>
      </div>
      <table v-else class="help-docs-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Descripción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in docs" :key="item.id">
            <td>
              <a :href="contentUrl(item)" target="_blank" rel="noopener">{{ item.filename }}</a>
            </td>
            <td>{{ item.description || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { vuex } from "@/components/mixin/vuex.js";
import { draggableDiv } from "@/components/mixin/draggableDiv.js";
import { restDocument } from "@/components/mixin/restDocument.js";

export default {
  name: "HelpDocuments",
  mixins: [vuex, draggableDiv, restDocument],
  data() {
    return {
      loading: false,
      error: "",
      minimized: false,
      documentGroups: [],
      selectedGroup: "",
    };
  },
  created() {
    this.loading = true;
    this.getVisibleDocumentGroups()
      .then((response) => {
        this.documentGroups = response.data || [];
        if (!this.documentGroups.length) {
          this.docs = [];
          return;
        }
        this.selectedGroup = this.documentGroups[0].id;
        return this.loadDocuments();
      })
      .catch((error) => {
        console.error(error);
        this.error = "No es posible cargar los documentos";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    loadDocuments() {
      if (!this.selectedGroup) {
        this.docs = [];
        this.loading = false;
        return Promise.resolve();
      }
      this.loading = true;
      this.error = "";
      return this.getVisibleDocs(this.selectedGroup)
        .then((response) => {
          this.docs = response.data || [];
        })
        .catch((error) => {
          console.error(error);
          this.docs = [];
          this.error = "No es posible cargar los documentos";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.selectMapTool("help", false);
    },
  },
  mounted() {
    this.makeDraggable("helpDocumentsID");
  },
};
</script>

<style scoped lang="scss">
.help-tool-window {
  position: fixed;
  width: 420px;
  max-height: 70vh;
  // background: #fff;
  // border-radius: 4px;
  // box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 100000001;
  // display: flex;
  // flex-direction: column;
  // user-select: none;
}

.help-docs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #e0e0e0;
  cursor: move;
  font-weight: 600;
  background: #f9f9f9;
  border-radius: 8px 8px 0 0;
}

.help-docs-title {
  font-size: 14px;
}

.header-actions {
  display: flex;
  gap: 4px;
}

.btn-icon {
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 2px 8px;
  color: #333;
  border-radius: 4px;

  &:hover {
    background: #e5e5e5;
  }
}

.help-docs-body {
  padding: 12px;
  overflow-y: auto;
  max-height: calc(70vh - 48px);
  user-select: text;
}

.help-docs-group-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
  color: var(--color-navy);
  font-size: 0.8rem;
  font-weight: 600;

  select {
    width: 100%;
    padding: 0.4rem 0.5rem;
    border: 1px solid var(--color-line);
    border-radius: 4px;
    background: var(--color-white);
    color: var(--color-graphite);
  }
}

.help-docs-state {
  padding: 8px 4px;
  font-size: 13px;
  color: #333;
}

.help-docs-error {
  color: #b00020;
}
.help-docs-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  min-height: 190px;
  padding: 24px 20px;

  background: var(--color-mist);
  border: 1px dashed var(--color-line);
  border-radius: 6px;

  text-align: center;

  strong {
    color: var(--color-navy);
    font-size: 0.92rem;
    font-weight: 700;
    line-height: 1.3;
  }

  p {
    max-width: 280px;
    margin: 0;

    color: var(--color-ghost);
    font-size: 0.8rem;
    line-height: 1.5;
  }
}

.help-docs-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 46px;
  height: 46px;
  margin-bottom: 2px;

  background: var(--color-white);
  border: 1px solid var(--color-line);
  border-radius: 50%;

  color: var(--color-steel);

  svg {
    width: 22px;
    height: 22px;

    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}
.help-docs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;

  th,
  td {
    text-align: left;
    padding: 6px 8px;
    border-bottom: 1px solid #e0e0e0;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    vertical-align: top;
  }

  th {
    background: #f9f9f9;
    font-weight: 600;
  }

  a {
    color: #1976d2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
